import { VehicleType } from "@/src/pages/dealer/components/VehicleCheckBoxGroup/VehicleCheckBoxGroup";

import { atomWithStorage } from "jotai/utils";

export interface SearchFiltersAtom {
  vehicleType?: VehicleType[];
  bikeType?: string[];
  caravanSubtype?: string[];
  make?: string[];
  modelYear?: { start?: number; end?: number };
  fuelType?: string[];
  distance?: number;
  sellerDelivers?: boolean;
  gearType?: string[];
  mileage?: { start?: number; end?: number };
  targetPrice?: { start?: number; end?: number };
}

export const dealerActiveAuctionSearchFiltersAtom = atomWithStorage<
  SearchFiltersAtom | undefined
>(
  "dealerActiveAuctionSearchFiltersAtom",
  { sellerDelivers: true, distance: 0 },
  undefined,
  { getOnInit: true }
);

export interface SavedSearchAtom {
  name: string;
  searchFilters: SearchFiltersAtom;
}

export const dealerSavedSearchFiltersAtom = atomWithStorage<
  SavedSearchAtom[] | undefined
>("dealerSavedSearchFiltersAtom", undefined, undefined, { getOnInit: true });
